/**
 * data API
 * data API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DynamicOperand } from './dynamicOperand';


export interface Ordering { 
    operand: DynamicOperand;
    order: Ordering.OrderEnum;
}
export namespace Ordering {
    export type OrderEnum = 'ASC' | 'DESC';
    export const OrderEnum = {
        ASC: 'ASC' as OrderEnum,
        DESC: 'DESC' as OrderEnum
    };
}
